import { Breadcrumb, BreadcrumbItemType } from "@p0security/ui";
import React, { ReactElement } from "react";
import { Link } from "react-router-dom";

export type LogoBreadcrumbItem = {
  icon?: ReactElement;
  to?: string;
  label: string;
};

/** Breadcrumbs with displayed logos */
export const LogoBreadcrumb: React.FC<{
  items: LogoBreadcrumbItem[];
}> = ({ items }) => {
  const breadcrumbItems: BreadcrumbItemType[] = items.map(
    ({ icon, to, label }, ix) => {
      const el = (
        <div className="flex items-center">
          {icon ? (
            <>
              {icon}&nbsp;{label}
            </>
          ) : (
            label
          )}
        </div>
      );
      return {
        key: ix,
        title: <>{to ? <Link to={to}>{el}</Link> : el}</>,
      };
    }
  );

  // Force center alignment of breadcrumb content for proper icon display.
  return (
    <Breadcrumb
      className="[&_ol]:inline-flex! [&_ol]:items-center! [&_ol_li]:inline-flex! [&_ol_li]:items-center! [&_ol_li_.ant-breadcrumb-link]:inline-flex! [&_ol_li_.ant-breadcrumb-link]:items-center! [&_ol_li_div]:inline-flex! [&_ol_li_div]:items-center!"
      items={breadcrumbItems}
    />
  );
};
